'use strict';

export class SortingBase {
  
    // Sorting variables
    sortBy: string;
    sortDesc: boolean;

    constructor() {
        //Initialize sorting
        this.changeSortBy('_id');
        this.sortDesc = true;
    }

    changeSortBy(field: string) {
        this.sortBy = field;
    }

    changeSortDirection() {
        this.sortDesc = !this.sortDesc;
    }

}



// WEBPACK FOOTER //
// ./client/app/shared/sorting.base.ts